import {Component, DoCheck, OnInit} from '@angular/core';
import {UsuarioServices} from '../services/usuario.services';
import {PERMISOS} from '../../variables';

@Component({
  selector:"menu-app",
  templateUrl:"../templates/menu.template.html"
})
export class MenuComponent implements DoCheck, OnInit{

  isLogin:boolean = true;
  adminCol:boolean = true;
  semanaCol:boolean = true;
  comisionesCol:boolean = true;
  reportesCol:boolean = true;
  reportesInv:boolean = true;
  reportesReg:boolean = true;
  reportesRVG:boolean = true;
  adminVenRVG:boolean = true;
  misTiendasCol:boolean = true;

  verComisiones:boolean = false;
  verCargos:boolean = false;
  verReportes:boolean = false;
  verRVG:boolean = false;
  adminRVG:boolean = false;
  crearVisitasRVG:boolean = false;
  verReportePPTO:boolean = false;

  constructor(private us:UsuarioServices){}

  ngOnInit(): void {
    this.us.comprobarPermisos(PERMISOS.ADMINCARGOS).then(d=>{
      this.verCargos = d;
    });

    this.us.comprobarPermisos(PERMISOS.ADMINCOMISIONES).then(d=>{
      this.verComisiones = d;
    });

    this.us.comprobarPermisos(PERMISOS.VERREPORTES).then(d=>{
      this.verReportes = d;
    });

    this.us.comprobarPermisos(PERMISOS.VERRVG).then(d=>{
      this.verRVG = d;
    });

    this.us.comprobarPermisos(PERMISOS.ADMINRVG).then(d=>{
      this.adminRVG = d;
    });

    this.us.comprobarPermisos(PERMISOS.CREARVISITASRVG).then(d=>{
      this.crearVisitasRVG = d;
    });

    this.us.comprobarPermisos(PERMISOS.VERREPORTEPPTO).then(d=>{
      this.verReportePPTO = d;
    })

  }


  logout(){
    this.us.logout();
  }

  ngDoCheck(): void {
    this.isLogin = this.us.isLogin();
  }

}
